// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__1WTkp","links":"LoginForm_links__4GPWB","checkBoxBox":"LoginForm_checkBoxBox__VN0sn","span":"LoginForm_span__62TmW"};